import type { CommonFinanceInfoType } from "../../../../../common-deprecated/types/CommonTypes";
import {
    type EquipmentV2FinanceActionsType,
    EQUIPMENT_V2_FINANCE_ERROR,
    EQUIPMENT_V2_FINANCE_FINISH_FETCH,
    EQUIPMENT_V2_FINANCE_START_FETCH,
} from "../actions/EquipmentFinanceActions";
import type { QuoteInfoType } from "../../../../../common-deprecated/types/FinanceInsuranceRateTypes";

export type EquipmentV2FinanceRateStateType = {
    itemRates: { [index: string]: string };
    fetching: boolean;
    error: boolean;
    total: string;
    totalWithoutPromotions: string;
    info: CommonFinanceInfoType;
    quotes: {
        finance: string | null;
        insurance: string | null;
        enabled: boolean;
    };
    quoteInfo: QuoteInfoType;
};

export const initialState: EquipmentV2FinanceRateStateType = {
    itemRates: {},
    fetching: false,
    error: false,
    total: "0",
    totalWithoutPromotions: "0",
    info: {
        effectiveInterestRate: "",
        annualInterestRate: "",
        productName: "",
        term: "",
        disclaimer: {
            value: "",
        },
    },
    quotes: {
        enabled: false,
        finance: null,
        insurance: null,
    },
    quoteInfo: {},
};

const financeReducer = (
    state: EquipmentV2FinanceRateStateType = initialState,
    action: EquipmentV2FinanceActionsType,
): EquipmentV2FinanceRateStateType => {
    switch (action.type) {
        case EQUIPMENT_V2_FINANCE_START_FETCH: {
            return { ...state, fetching: true, error: false };
        }

        case EQUIPMENT_V2_FINANCE_ERROR: {
            return { ...state, fetching: false, error: true };
        }

        case EQUIPMENT_V2_FINANCE_FINISH_FETCH: {
            const { rates = {} } = action;

            const { total = "", totalWithoutPromotions = "", quoteInfo = {}, info } = action.result;

            return { ...state, itemRates: rates, fetching: false, info, total, totalWithoutPromotions, quoteInfo };
        }
        default:
            return state;
    }
};

export default financeReducer;
